import { Popup } from '@approvalmax/ui/src/components';
import { useAtom, useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { AddPersonPopup } from './AddPersonPopup';
import { addPersonPopupNodeState, addPersonPopupOpenState } from './AddPersonPopup.states';

export const useAddPersonPopup = () => {
    const [openAddPersonPopup, setOpenAddPersonPopup] = useAtom(addPersonPopupOpenState);
    const setAddPersonPopupNode = useSetAtom(addPersonPopupNodeState);

    const handleToggleAddPersonPopup = useCallback(
        (open: boolean) => {
            setOpenAddPersonPopup(open);
        },
        [setOpenAddPersonPopup]
    );

    const addPersonPopup = (
        <Popup
            size='small'
            open={openAddPersonPopup}
            dialogRef={setAddPersonPopupNode}
            onToggle={handleToggleAddPersonPopup}
        >
            <AddPersonPopup />
        </Popup>
    );

    return { addPersonPopup };
};

export const useToggleAddPersonPopup = () => {
    const setOpenAddPersonPopup = useSetAtom(addPersonPopupOpenState);

    const openAddPersonPopup = useCallback(() => {
        setOpenAddPersonPopup(true);
    }, [setOpenAddPersonPopup]);

    const closeAddPersonPopup = useCallback(() => {
        setOpenAddPersonPopup(false);
    }, [setOpenAddPersonPopup]);

    return { openAddPersonPopup, closeAddPersonPopup };
};
